/* @flow strict */

import _ from 'lodash';

export const shakeElement = (el: any) => {
  el.classList.add('shake');

  setTimeout(() => {
    el.classList.remove('shake');
  }, 1500);
};

export const setValidateClass = (el: any) => {
  if (!_.size(el.value)) {
    el.classList.add('validationElement');

    shakeElement(el);
  } else {
    el.classList.remove('validationElement');
  }
};

export const ToggleLeftMenu = (status: string) => {
  const wrapper = document.querySelector('.sparxo-layout.layout-main');

  if (status === 'hide') {
    wrapper.classList.add('hide-menu');
  } else {
    wrapper.classList.remove('hide-menu');
  }
}

export const ToggleOpacityOfContent = (opacity: number) => {
  const body = document.getElementById('react-app');

  body.style.opacity = opacity;
};
